import { Github, Linkedin, Mail, Instagram, Twitter, ExternalLink, Calendar, Phone } from 'lucide-react'

export const socialLinks = [
  {
    name: "GitHub",
    icon: Github,
    url: "https://github.com/vishalpanwar416",
    username: "@vishalpanwar416"
  },
  {
    name: "LinkedIn",
    icon: Linkedin,
    url: "https://linkedin.com/in/vishalpanwar416",
    username: "vishalpanwar416"
  },
  {
    name: "Email",
    icon: Mail,
    url: "mailto:vishalpanwar416@gmail.com",
    username: "vishalpanwar416@gmail.com"
  },
  {
    name: "Instagram",
    icon: Instagram,
    url: "https://instagram.com/vee.pyai",
    username: "@vee.pyai"
  },
  {
    name: "Twitter",
    icon: Twitter,
    url: "https://twitter.com/vishalpanwar416",
    username: "@vishalpanwar416"
  },
  {
    name: "Digital Card",
    icon: ExternalLink,
    url: "https://blinq.me/cTA1XtayJD14xDIFFz33",
    username: "blinq.me"
  }
]

export const contactLinks = [
  {
    icon: Mail,
    label: "Email",
    value: "vishalpanwar416@gmail.com",
    link: "mailto:vishalpanwar416@gmail.com"
  },
  {
    icon: Phone,
    label: "Phone",
    value: "+91 7500988212",
    link: "tel:+917500988212"
  },
  {
    icon: Linkedin,
    label: "LinkedIn",
    value: "linkedin.com/in/vishalpanwar416",
    link: "https://linkedin.com/in/vishalpanwar416"
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: "instagram.com/vee.pyai",
    link: "https://instagram.com/vee.pyai"
  },
  {
    icon: Twitter,
    label: "X (Twitter)",
    value: "twitter.com/vishalpanwar416",
    link: "https://twitter.com/vishalpanwar416"
  },
  {
    icon: ExternalLink,
    label: "Digital Card",
    value: "blinq.me/cTA1XtayJD14xDIFFz33",
    link: "https://blinq.me/cTA1XtayJD14xDIFFz33"
  },
  {
    icon: Calendar,
    label: "Book a Meeting",
    value: "cal.com/vishal-panwar-mz0tfc",
    link: "https://cal.com/vishal-panwar-mz0tfc"
  }
]

export const externalLinks = {
  leetcode: "https://leetcode.com/vishalpanwar416",
  github: "https://github.com/vishalpanwar416",
  resume: "/resume/Vishal_Panwar_Resume.pdf",
  calendarBooking: "https://cal.com/vishal-panwar-mz0tfc"
}
